import { switchNetwork } from 'app-lib/web3ReactUtils'
import { ChainId } from 'bzx-common/src/config/appConfig'
import { RootStore } from 'bzx-common/src/stores'
import * as mobx from 'mobx'

export default class ChainInfoVM {
  public rootStore: RootStore

  public switchNetwork(chainId: ChainId) {
    const { web3Connection } = this.rootStore
    if (web3Connection.isConnected) {
      switchNetwork(chainId)
    } else {
      web3Connection.setReadOnlyProvider(chainId)
    }
  }

  constructor({ rootStore }: { rootStore: RootStore }) {
    this.rootStore = rootStore
    mobx.makeAutoObservable(this, undefined, { autoBind: true, deep: false })
  }
}
